import { BaseRequestModel } from "./BaseModel/BaseRequestModel";

export class SBDReportRequestModel extends BaseRequestModel{
    documentTemplateID:number
    isTransectionalData:boolean=false
}